import React, { useRef, useEffect } from 'react';

const CustomScrollbar = ({ scrollTargetRef }) => {
  const thumbRef = useRef(null);
  const trackRef = useRef(null);

  useEffect(() => {
    const content = scrollTargetRef.current;
    const thumb = thumbRef.current;
    const track = trackRef.current;

    if (!content || !thumb || !track) {
        console.log("content", content);
        console.log("thumb", thumb);
        console.log("track", track);
        return;
    }
    track.style.width = `${content.clientWidth}px`;
    const updateThumb = () => {
      const ratio = content.clientWidth / content.scrollWidth;
      const thumbWidth = content.clientWidth * ratio;
      thumb.style.width = `${thumbWidth}px`;

      const scrollRatio = content.scrollLeft / (content.scrollWidth - content.clientWidth);
      const thumbLeft = scrollRatio * (content.clientWidth - thumbWidth);
      thumb.style.left = `${thumbLeft}px`;
    };

    const onScroll = () => updateThumb();
    content.addEventListener('scroll', onScroll);

    // Drag
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;

    const onMouseDown = (e) => {
      isDragging = true;
      startX = e.clientX;
      startScrollLeft = content.scrollLeft;
      document.body.style.userSelect = 'none';
    };

    const onMouseMove = (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - startX;
      const maxScroll = content.scrollWidth - content.clientWidth;
      const maxThumbMove = content.clientWidth - thumb.offsetWidth;
      const scrollRatio = maxScroll / maxThumbMove;

      content.scrollLeft = startScrollLeft + deltaX * scrollRatio;
    };

    const onMouseUp = () => {
      isDragging = false;
      document.body.style.userSelect = '';
    };

    thumb.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mousemove', onMouseMove)
    document.addEventListener('mouseup', onMouseUp)
    requestAnimationFrame(updateThumb)
    const resizeObserver = new ResizeObserver(updateThumb)
    resizeObserver.observe(content)
    const mutationObserver = new MutationObserver(() => requestAnimationFrame(updateThumb))
    mutationObserver.observe(content, {
      childList: true,
      subtree: true,
      attributes: true,
    })
    return () => {
      content.removeEventListener('scroll', onScroll);
      thumb.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      resizeObserver.disconnect();
    };
  }, [scrollTargetRef]);

  return (
    <div className="custom-scrollbar" ref={trackRef}>
      <div className="custom-scrollbar-thumb" ref={thumbRef}></div>
    </div>
  );
};

export default CustomScrollbar;
